import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Helper = {
    handleApiResponse(response, text = "") {
        console.log(response);

        if (response.data.status) {
            // Display a toast notification when the condition is met
            toast.success(text, {
                // You can customize options here, like autoClose, position, etc.
                autoClose: 3000, // Auto close the toast after 3 seconds
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    },

    toast(text, type) {
        const options = {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
        };

        if (type === 'success') {
            toast.success(text, options);

        } else if (type === 'error') {
            toast.error(text, options);

        } else {
            toast.info(text, options);
        }
    },
};

export default Helper;